
import { defineComponent } from "vue";
//Importar api cliente
import api from "@/servicios/apiSRP";
import mixinRequisicionPago from "../mixins/mixinRequisicionPago";
import { SRP } from "@/servicios/api"; // eslint-disable-line

export default defineComponent({
  name: "DetalleCentroCosto",
  mixins: [mixinRequisicionPago],
  data() {
    return {
      catalogos: {
        Sucursales: [] as SRP.Models.VwSucursal[],
        Areas: [] as SRP.Models.VwArea[],
        Grupos: [] as SRP.Models.GrupoHirCasa[]
      },
      AreasElegidas: [] as any,
      MetroElegidas: [] as any,
      ForaneasElegidas: [] as any,
      GruposElegidos: [] as any,
      sumaSucursales: 0,
      sumaAreas: 0,
      sumaGrupos: 0,
      sumaTotal: 0,
      date: new Date().toISOString().substr(0, 10)
    };
  },
  props: {
    centroCostos: String
  },
  mounted() {
    this.ObtenerCatalogoSucursales();
    this.ObtenerCatalogoAreas();
    this.ObtenerCatalogoGrupos();
  },
  methods: {
    async ObtenerCatalogoSucursales() {
      var resp = await api.SRP.RequisicionPago.RequisicionPago.ObtenerCatalogoSucursales();
      this.catalogos.Sucursales = resp.data as SRP.Models.VwSucursal[];
      if (this.catalogos.Sucursales != null) {
        this.CargarDatosSucursal();
      }
    },
    async ObtenerCatalogoAreas() {
      var resp = await api.SRP.RequisicionPago.RequisicionPago.ObtenerCatalogoAreas();
      this.catalogos.Areas = resp.data as SRP.Models.VwArea[];
      if (this.catalogos.Areas != null) {
        this.CargarDatosArea();
      }
    },
    async CargarDatosSucursal() {
      const jsonCentroCostos = JSON.parse(this.centroCostos as string, (key, value) => {
        if (typeof value === "string") {
          return value.toUpperCase();
        }
        return value;
      });

      if (jsonCentroCostos != 0) {
        this.catalogos.Sucursales.forEach((sucursal) => {
          jsonCentroCostos.sucursales.forEach((obj: any) => {
            if (sucursal.clave == obj.clave) {
              if (obj.esForanea) {
                (sucursal as any).monto = obj.monto || 0;
                this.ForaneasElegidas.push(sucursal);
              } else {
                (sucursal as any).monto = obj.monto || 0;
                this.MetroElegidas.push(sucursal);
              }
              this.sumaSucursales = jsonCentroCostos.sucursales.reduce(
                (acc: any, obj: any) => acc + parseFloat(obj.monto || 0),
                0
              );
            }
          });
        });
      }
    },
    async CargarDatosArea() {
      const jsonCentroCostos = JSON.parse(this.centroCostos as string, (key, value) => {
        if (typeof value === "string") {
          return value.toUpperCase();
        }
        return value;
      });
      if (jsonCentroCostos != 0) {
        this.catalogos.Areas.forEach((area) => {
          jsonCentroCostos.areas.forEach((areacc: any) => {
            if (area.clave == areacc.clave) {
              (area as any).monto = areacc.monto || 0;
              this.AreasElegidas.push(area);
              this.sumaAreas = jsonCentroCostos.areas.reduce(
                (acc: any, obj: any) => acc + parseFloat(obj.monto || 0),
                0
              );
            }
          });
        });
      }
    },
    async ObtenerCatalogoGrupos() {
      var resp = await api.SRP.RequisicionPago.RequisicionPago.ObtenerCatalogoGrupoHirCasa();
      this.catalogos.Grupos = resp.data as SRP.Models.GrupoHirCasa[];
      if (this.catalogos.Grupos != null) {
        this.CargarDatosGrupo();
      }
    },
    async CargarDatosGrupo() {
      const jsonCentroCostos = JSON.parse(this.centroCostos as string, (key, value) => {
        if (typeof value === "string") {
          return value.toUpperCase();
        }
        return value;
      });
      if (jsonCentroCostos != 0 && jsonCentroCostos.grupos) {
        this.catalogos.Grupos.forEach((grupo) => {
          jsonCentroCostos.grupos.forEach((grupocc: any) => {
            if (grupo.clave == grupocc.clave) {
              (grupo as any).monto = grupocc.monto || 0;
              this.GruposElegidos.push(grupo);
              this.sumaGrupos = jsonCentroCostos.grupos.reduce(
                (acc: any, obj: any) => acc + parseFloat(obj.monto || 0),
                0
              );
            }
          });
        });
      }
    }
  }
});
